import http from "../api/server";
import { DOOR_INSPECTION_API } from "../api/apiPath";

export const downloadPropertyInspectionPdf = async ({
  propertyId,
  inspectionReferenceNumber,
}) => {
  const response = await http.get(DOOR_INSPECTION_API, {
    params: {
      propertyId,
      inspectionReferenceNumber,
    },
  });

  const data = response?.data;
  const fileURL = data?.downloadUrl;
  const formattedFileName = data?.fileName?.replace(/\s+/g, "_");
  const fileName = formattedFileName || "Downloaded_Report.pdf";

  
// const downloadUrl =
//   `${fileURL}&response-content-disposition=` +
//   `attachment%3B%20filename%3D${fileName}`;


  if (fileURL) {
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return {
    ...data,
    fileURL,
    fileName,
  };
};
